export default __webpack_public_path__ + "static/media/NEC.f3460923.png";